// FOUNDATION §11 / §12 — degrade by dropping instance counts, never by rendering everything.
const mobile =
  typeof window !== 'undefined' &&
  (globalThis.innerWidth < 820 || /Mobi|Android/i.test(navigator.userAgent))

export const IS_MOBILE = mobile

export const Q = mobile
  ? { glyphs: 14000, nearGlyphs: 180, sheets: 1400, dpr: 1.5 }
  : { glyphs: 40000, nearGlyphs: 420, sheets: 3000, dpr: 2 }
